var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "menu_svg2__a",
    x1: 50.71,
    x2: 173.51,
    y1: 150.32,
    y2: 24.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#menu_svg2__a",
    id: "menu_svg2__c",
    x1: 18.77,
    x2: 141.58,
    y1: 119.03,
    y2: -6.33
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#menu_svg2__a",
    id: "menu_svg2__d",
    x1: 82.64,
    x2: 205.45,
    y1: 181.61,
    y2: 56.24
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M191.67 91.67H8.33a8.33 8.33 0 0 0 0 16.66h183.33a8.33 8.33 0 0 0 0-16.66Z",
    style: {
      fill: "url(#menu_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33 44.44h183.33a8.33 8.33 0 0 0 0-16.66H8.33a8.33 8.33 0 0 0 0 16.66",
    style: {
      fill: "url(#menu_svg2__c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.67 155.56H8.33a8.33 8.33 0 0 0 0 16.66h183.33a8.33 8.33 0 0 0 0-16.66Z",
    style: {
      fill: "url(#menu_svg2__d)",
      strokeWidth: 0
    }
  }));
};
export default SvgMenu;